import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { HomePage } from "@/pages/HomePage";
import { ParticuliersPage } from "@/pages/ParticuliersPage";
import { ProfessionnelsPage } from "@/pages/ProfessionnelsPage";
import { ContactPage } from "@/pages/ContactPage";
import { AuthPage } from "@/pages/AuthPage";
import { AdminPage } from "@/pages/AdminPage";
import { EspaceClientPage } from "@/pages/EspaceClientPage";
import { EmailVerificationPage } from "@/pages/EmailVerificationPage";

function App() {
  return (
    <HelmetProvider>
    <div className="App min-h-screen flex flex-col bg-white">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/particuliers" element={<ParticuliersPage />} />
              <Route path="/professionnels" element={<ProfessionnelsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/connexion" element={<AuthPage />} />
              <Route path="/mon-espace" element={<EspaceClientPage />} />
              <Route path="/verification-email" element={<EmailVerificationPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
